(function () {
  'use strict';

  const MAX_PARAM_LENGTH = 100;

  function push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  const clean = value => String(value ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

  // Normalize, dedupe and sort, so equal combinations always report the same
  const tidy = list => [...new Set(list.map(clean).filter(Boolean))].sort();

  // interior-paint stores the colors in ?colors=beige,black
  function colorsInUrl() {
    const value = new URLSearchParams(window.location.search).get('colors');
    return value ? tidy(value.split(',')) : [];
  }

  // The rest store the tags at the following path: /collections/<handle>/<tag-a>+<tag-b>
  function filtersInUrl(url) {
    let parsed;

    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return [];
    }

    const colors = parsed.searchParams.get('colors');
    if (colors) return tidy(colors.split(','));

    const parts = parsed.pathname.split('/').filter(Boolean);
    const index = parts.indexOf('collections');
    const tags = index === -1 ? '' : parts[index + 2];

    return !tags || tags === 'products' ? [] : tidy(decodeURIComponent(tags).split('+'));
  }

  function groupOf(el) {
    const heading = el
      .closest('.collection-sidebar__group')
      ?.querySelector('.collapsible-trigger-btn');

    return clean(heading?.getAttribute('data-filter-group')) || 'unknown';
  }

  function pushFilter(action, group, value, filters) {
    push({
      event: 'filter_applied',
      filter_action: action,
      filter_group: group,
      filter_value: value,
      filter_count: filters.length,
      filter_count_label: filters.length >= 5 ? '5+' : String(filters.length),
      filters_applied: filters.join('|').slice(0, MAX_PARAM_LENGTH),
      is_multi_filter: filters.length > 1 ? 'true' : 'false',
      collection_path: window.location.pathname
    });
  }

  function pushSort(value, label, ui) {
    const sort = clean(value);
    if (!sort) return;

    push({
      event: 'sort_applied',
      sort_value: sort,
      sort_label: clean(label) || sort,
      sort_ui: ui,
      filter_count: filtersInUrl(window.location.href).length,
      collection_path: window.location.pathname
    });
  }

  document.addEventListener('click', e => {
    const target = e.target;
    if (!target?.closest) return;

    // Interior-paint swatches: they don't reload; we calculate the toggle
    const swatch = target.closest('.color-filter-swatch');
    if (swatch) {
      const color = clean(swatch.dataset.color);
      const current = colorsInUrl();
      const wasActive = current.includes(color);
      const next = wasActive ? current.filter(c => c !== color) : [...current, color];

      pushFilter(wasActive ? 'remove' : 'add', groupOf(swatch), color, tidy(next));
      return;
    }

    // Color remove chips (href="#", the state is not in the link)
    const chip = target.closest('.color-filter-remove');
    if (chip) {
      const removed = clean(chip.dataset.color);
      pushFilter('remove', 'color', removed, colorsInUrl().filter(c => c !== removed));
      return;
    }

    if (target.closest('.collection-sidebar__group--reset a')) {
      pushFilter('reset', 'reset', 'reset', []);
      return;
    }

    // Sort dropdown on desktop: the value is in the link's href
    const sortLink = target.closest('.collection-filter__menu a[href*="sort_by="]');
    if (sortLink) {
      const url = new URL(sortLink.href, window.location.origin);
      pushSort(url.searchParams.get('sort_by'), sortLink.textContent, 'dropdown');
      return;
    }

    // Tags that navigate: the href already contains the resulting state
    const tag = target.closest('.collection-sidebar__group .tag-list a, .tag-list--active-tags a');
    const href = tag?.getAttribute('href');
    if (!href || href === '#') return;

    pushFilter(
      tag.closest('li')?.classList.contains('tag--active') ? 'remove' : 'add',
      groupOf(tag),
      clean(tag.textContent),
      filtersInUrl(tag.href)
    );
  }, true);

  // Sort on mobile (radios in the drawer) and on the legacy collection template
  document.addEventListener('change', e => {
    const target = e.target;
    if (!target) return;

    if (target.name === 'sortby-radio' && target.checked) {
      const label = target.closest('.collection-filter__input-wrapper')?.querySelector('label');
      pushSort(target.value, label?.textContent, 'mobile_radio');
    } else if (target.id === 'SortBy') {
      pushSort(target.value, target.options[target.selectedIndex]?.text, 'select');
    }
  }, true);
})();
